<template>
    <datatable :isLoading.sync="datatable.isLoading"
               :columns="datatable.columns"
               :rows="datatable.rows"
               :total="datatable.total"
               :queryParams="datatable.queryParams"
               v-show="datatable.showTable"
               :show-title="false"
               :showPaginate="false"
    >
    </datatable>
</template>
<script>
import StudentDocumentService from "@/services/StudentDocumentService";
import showErrors from "@/helpers/showErrors";

export default {
    props:{
        studentProgramId:{
            required:true
        }
    },
    data(){
        return {
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: this.toUpperCase('explanation'),
                        field: 'explanation',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('date'),
                        field: 'date',
                        hidden: false,
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: 'id',
                    page: 1,
                    limit: -1
                }
            },
        }
    },
    created() {
      this.getLogs()
    },
    methods:{
        getLogs(){
            this.datatable.showTable=true
            StudentDocumentService.logs(this.studentProgramId)
                .then(response => {
                    this.datatable.rows=response.data.data
                })
                .catch(e => {
                    showErrors(e, null)
                })
        },
    }
}
</script>

<style scoped>

</style>
